import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const fetchConfig = () => api.get("/config").then((r) => r.data);
export const fetchMenu = () => api.get("/menu").then((r) => r.data);
export const fetchPricebook = () => api.get("/pricebook").then((r) => r.data);
export const updatePricebookEntry = (name, payload) =>
  api.put(`/pricebook/${encodeURIComponent(name)}`, payload).then((r) => r.data);
export const deletePricebookEntry = (name) =>
  api.delete(`/pricebook/${encodeURIComponent(name)}`).then((r) => r.data);

// ----- Wholesale invoicing -----
export const listVendors = () => api.get("/vendors").then((r) => r.data);
export const createVendor = (payload) => api.post("/vendors", payload).then((r) => r.data);
export const updateVendor = (id, payload) => api.put(`/vendors/${id}`, payload).then((r) => r.data);
export const deleteVendor = (id) => api.delete(`/vendors/${id}`).then((r) => r.data);

export const listInvoices = (params = {}) => api.get("/invoices", { params }).then((r) => r.data);
export const createInvoice = (payload) => api.post("/invoices", payload).then((r) => r.data);
export const updateInvoice = (id, payload) => api.put(`/invoices/${id}`, payload).then((r) => r.data);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`).then((r) => r.data);
export const sendInvoice = (id, payload = {}) =>
  api.post(`/invoices/${id}/send`, payload, { timeout: 90000 }).then((r) => r.data);
export const updateInvoiceStatus = (id, status) => api.patch(`/invoices/${id}/status`, { status }).then((r) => r.data);
export const fetchInvoicePdfBlob = (id) =>
  api.get(`/invoices/${id}/pdf`, { responseType: "blob", timeout: 60000 }).then((r) => r.data);
export const fetchInvoiceHtml = (id) =>
  api.get(`/invoices/${id}/html`, { responseType: "text", transformResponse: [(x) => x] }).then((r) => r.data);

// ----- Email settings (Gmail SMTP) -----
export const fetchGmailSettings = () => api.get("/settings/gmail").then((r) => r.data);
export const saveGmailSettings = (payload) => api.put("/settings/gmail", payload).then((r) => r.data);
export const clearGmailSettings = () => api.delete("/settings/gmail").then((r) => r.data);
export const testGmailSettings = () => api.post("/settings/gmail/test").then((r) => r.data);

// ----- Franchise settings & royalty invoices -----
export const listFranchiseSettings = () => api.get("/settings/franchise").then((r) => r.data);
export const getFranchiseSettings = (spoke) =>
  api.get(`/settings/franchise/${encodeURIComponent(spoke)}`).then((r) => r.data);
export const saveFranchiseSettings = (spoke, payload) =>
  api.put(`/settings/franchise/${encodeURIComponent(spoke)}`, payload).then((r) => r.data);

export const previewNetSales = (spoke, year, month) =>
  api.get("/royalty-invoices/net-sales", { params: { spoke, year, month } }).then((r) => r.data);
export const listRoyaltyInvoices = (params = {}) =>
  api.get("/royalty-invoices", { params }).then((r) => r.data);
export const createRoyaltyInvoice = (payload) =>
  api.post("/royalty-invoices", payload).then((r) => r.data);
export const updateRoyaltyInvoiceStatus = (id, status) =>
  api.patch(`/royalty-invoices/${id}/status`, { status }).then((r) => r.data);
export const deleteRoyaltyInvoice = (id) =>
  api.delete(`/royalty-invoices/${id}`).then((r) => r.data);
export const fetchRoyaltyInvoicePdfBlob = (id) =>
  api.get(`/royalty-invoices/${id}/pdf`, { responseType: "blob", timeout: 60000 }).then((r) => r.data);
export const fetchFranchiseDashboard = () => api.get("/franchise/dashboard").then((r) => r.data);
export const createFranchise = (payload) => api.post("/settings/franchise", payload).then((r) => r.data);
export const updateFranchiseColor = (spoke, color) =>
  api.put(`/settings/franchise/${encodeURIComponent(spoke)}/color`, { color }).then((r) => r.data);
export const fetchSpokes = () => api.get("/spokes").then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const updateOrder = (id, payload) => api.put(`/orders/${id}`, payload).then((r) => r.data);
export const listOrders = (params = {}) => api.get("/orders", { params }).then((r) => r.data);
export const fetchStats = (params = {}) => api.get("/orders/stats", { params }).then((r) => r.data);
export const fetchCommissions = (params = {}) => api.get("/commissions/stats", { params }).then((r) => r.data);
export const updatePaymentStatus = (id, payment_status) =>
  api.patch(`/orders/${id}/payment-status`, { payment_status }).then((r) => r.data);
export const deleteOrder = (id) => api.delete(`/orders/${id}`).then((r) => r.data);

const TOKEN_KEY = "dotr_token";

export const exportCsvUrl = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) qs.append("token", token);
  return `${API}/orders/export${qs.toString() ? `?${qs}` : ""}`;
};
